import { SubjectId } from './types';

/** Areas of study each subject's question bank groups tags under, in display order. Mirrors backend/app/subjects.py. */
export const SUBJECT_AREAS: Record<SubjectId, readonly string[]> = {
  methods: ['Functions', 'Calculus', 'Probability'],
  specialist: ['Functions', 'Algebra', 'Calculus', 'Vectors', 'Mechanics'],
};
